module.exports = __webpack_public_path__ + "static/media/logo.99c8f204.svg";